import React, { useState } from 'react';
import {
  Hidden,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  withStyles,
  Paper,
  InputBase,
  InputAdornment,
  Tooltip,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import styles from '../common/Table/styles';
import Loading from '../common/Loading';
import SectionHeader from '../common/SectionHeader';
import Surface from '../common/Surface';
import ReactJson from 'react-json-view';
import SearchIcon from '@material-ui/icons/Search';
import { Link } from 'react-router-dom';
import { Visibility, Add } from '@material-ui/icons';
import { PrimaryButton } from '../common/Button';
import config from '../../utils/config';


export const ROWS_PER_PAGE = 10;

const UserComponent = ({
  classes,
  data,
  page,
  dataCount,
  path,
  loading,
  columns,
  handleChangePage,
  enableSearch,
  searchWord,
  handleSearchChange,
  title,
  enableActions,
  handleOpenForm
}) => {
  const theme = useTheme()
  const [rowIdOver, setRowIdOver] = useState('');
  const handleOver = rowId => setRowIdOver(rowId);
  const handleLeave = () => setRowIdOver('');
  const smallScreen = useMediaQuery(theme.breakpoints.down(1020));

  const renderTableHeader = () =>
    columns.map(column => {
      const Cell = () => (
        <TableCell
          style={{ color: '#353535de', minWidth: column.minWidth }}
          classes={{ root: classes.tableHead }}
        >
          {column.label}
        </TableCell>
      );

      if (column.hidden) {
        return (
          <Hidden key={column.id} {...column.hidden}>
            <Cell />
          </Hidden>
        );
      } else {
        return <Cell key={column.id} />;
      }
    });
    
  const renderTableRow = row =>
    columns.map(column => {
      const cellProps = {
        key: column.id,
        classes: { root: classes.tableCell },
      };

      if (column.hidden) {
        return (
          <Hidden key={column.id} {...column.hidden}>
            <TableCell {...cellProps}>
              {column.field && row[column.id] ? row[column.id][column.field] : row[column.id]}
            </TableCell>
          </Hidden>
        );
      } else {
        if (column.field === 'affectedEntity') {
          return (
            <TableCell {...cellProps}>
              { row[column.id] ? <ReactJson src={row[column.id]}  name={'Detalle'} collapsed={true} collapseStringsAfterLength={50} displayDataTypes={false} /> : '' }
            </TableCell>
          )
        } else if (column.field === 'user') {
          return (
            <TableCell {...cellProps}>
              {row[column.id] ? row[column.id].firstName + ' ' + row[column.id].lastName : ''}
            </TableCell>
          );
        }
        return (
          <TableCell {...cellProps}>
            {column.field && row[column.id] ? row[column.id][column.field] : row[column.id]}
          </TableCell>
        );
      }
    });


  const renderActions = row => (
    <div className={classes.iconsContainer}>
      <Tooltip title="Ver información">
        <Link to={`${path}/${row._id}`}>
          <IconButton>
            <Visibility />
          </IconButton>
        </Link>
      </Tooltip>
    </div>
  );

  return (
    <div>
      <SectionHeader title={title}>
        <PrimaryButton onClick={() => handleOpenForm()} startIcon={<Add />}>
          Nuevo usuario
        </PrimaryButton>
      </SectionHeader>

      {!enableSearch ? null : (
              <Paper
                variant="outlined"
                style={{ minWidth: '40rem', borderRadius: '3rem' }}
                className={classes.root}
              >
                <InputBase
                  style={{ width: '100%', marginLeft: '1.5rem' }}
                  placeholder="Ingrese su consulta"
                  value={searchWord}
                  onChange={handleSearchChange}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                />
              </Paper>
            )}
      <Surface className={classes.root}>
        {loading ? (
          <Loading style={{ height: 639 }} />
        ) : (
          <div>
            <TableContainer style={{ borderRadius: 4 }}>
            { dataCount === 0 ? 
                <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginTop: '3rem',
                  marginBottom: '3rem',
                  }}
                >
                <span style={{ fontSize: '1.5rem' }}>
                  No se encontraron usuarios con ese criterio
                </span>
                <span style={{ fontSize: '1.2rem', color: '#999' }}>Intente otra consulta</span>
              </div>
             :
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {renderTableHeader()}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data
                    .map(row => {
                        const showActions = rowIdOver === row._id || smallScreen;
                        return (
                            <TableRow
                            hover
                            tabIndex={-1}
                            key={row._id}
                            onMouseLeave={() => handleLeave()}
                            onMouseOver={() => handleOver(row._id)}
                            >
                          {renderTableRow(row)}
                          <TableCell
                            style={{ paddingTop: 2, paddingBottom: 2 }}
                            classes={{ root: classes.tableCell }}
                            >
                            { showActions && enableActions ? (
                              renderActions(row)
                            ) : (
                              <div style={{ height: '100%', width: '100%' }} />
                            )}
                          </TableCell>
                        </TableRow>
                      );
                  })}
                </TableBody>
              </Table>
            }  
            </TableContainer>
            { dataCount > 0 && 
              <TablePagination
                rowsPerPageOptions={[ROWS_PER_PAGE]}
                component="div"
                count={dataCount}
                rowsPerPage={ROWS_PER_PAGE}
                page={page}
                labelDisplayedRows={({ from, to, count }) => from + ' al ' + to + ' de ' + count}
                onChangePage={handleChangePage}
                classes={{ root: classes.pagination }}
              />
            }
          </div>
        )}
      </Surface>
    </div>
  );
};

export default withStyles(styles)(UserComponent);
